import { ref } from 'vue';
import { defineStore } from 'pinia';
import { canAccessFeature as canAccessUserFeature } from '@/js/core/utils/feature-access';

export const useUserStore = defineStore('userStore', () => {
  const id = ref(null);

  const uuid = ref(null);

  const name = ref(null);

  const firstName = ref(null);

  const canModerateComments = ref(false);

  const isGuest = ref(false);

  const guestFeatures = ref([]);

  const accessibleFeatures = ref([]);

  const canAccessFeature = feature => {
    return canAccessUserFeature(
      {
        accessibleFeatures: accessibleFeatures.value,
      },
      feature
    );
  };

  return {
    id,
    uuid,
    name,
    firstName,
    canModerateComments,
    isGuest,
    guestFeatures,
    accessibleFeatures,
    canAccessFeature,
  };
});
